/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTankcarOilSideView: {
  name: 'tankcar-oil-side-view';
  data: string;
} = {
  name: 'tankcar-oil-side-view',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 1.5a4 4 0 0 0-1.999 7.466A.504.504 0 0 0 3.5 9v1.5H1a.5.5 0 0 0 0 1h.768a2 2 0 1 0 3.465 0h5.535a2 2 0 1 0 3.465 0H15a.5.5 0 0 0 0-1h-2.5V9l-.001-.034A4 4 0 0 0 10.5 1.5h-5Zm-1 9h7V9.374c-.32.082-.655.126-1 .126h-5c-.345 0-.68-.044-1-.126V10.5Zm6-8a3 3 0 1 1 0 6h-5a3 3 0 0 1 0-6h5Zm-8 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm10-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" fill="currentColor"/></svg>`,
};
